// extracted by mini-css-extract-plugin
export var details = "_gw-0";
export var inspectorPopover = "_gw-1";